import React from "react";
import News from "../News";

export default function BlogSection({ data }) {
    const { tituloSeccion, subtituloSeccion, cantidad, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'blog';

    // El componente News ya maneja la obtención de datos de Strapi
    return <News titulo={tituloSeccion} subtitulo={subtituloSeccion} cantidad={cantidad} id={ancla} />;
}
